import { render, staticRenderFns } from "./DenominacionesConExcedentes.vue?vue&type=template&id=535c1888&scoped=true"
import script from "./DenominacionesConExcedentes.vue?vue&type=script&lang=ts"
export * from "./DenominacionesConExcedentes.vue?vue&type=script&lang=ts"
import style0 from "./DenominacionesConExcedentes.vue?vue&type=style&index=0&id=535c1888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535c1888",
  null
  
)

export default component.exports